import { CadNextNotificationTypeEnumType } from '@mark43/cad-api';

type EventPanelNotificationGroup = 'MAIN' | 'REPORTING_PARTY';

export const eventPanelEventNotificationToNotificationGroup: Partial<
    Record<CadNextNotificationTypeEnumType, EventPanelNotificationGroup>
> = {
    EVENT_LOCATION: 'MAIN',
    EVENT_LOCATION_SUB_PREMISE: 'MAIN',
    CROSS_STREETS: 'MAIN',
    EVENT_LOCATION_NOTES: 'MAIN',
    SUBDIVISION: 'MAIN',
    BEAT: 'MAIN',
    CFS: 'MAIN',
    ADDITIONAL_CFS: 'MAIN',
    RISK_LEVEL: 'MAIN',
    EVENT_PRIORITY: 'MAIN',
    EVENT_LABELS: 'MAIN',
    DISPATCH_AREA: 'MAIN',
    AGENCY: 'MAIN',
    RADIO_CHANNEL: 'MAIN',
    EVENT_STAFF_COUNT: 'MAIN',
    UNIT_STAFF_COUNT: 'MAIN',
    NEW_EVENT: 'MAIN',
    EVENT_MERGED: 'MAIN',
    EVENT_UNMERGED: 'MAIN',
    REPORTING_PARTY_FIRST_NAME: 'REPORTING_PARTY',
    REPORTING_PARTY_LAST_NAME: 'REPORTING_PARTY',
    REPORTING_PARTY_LOCATION: 'REPORTING_PARTY',
    REPORTING_PARTY_LOCATION_SUB_PREMISE: 'REPORTING_PARTY',
    REPORTING_PARTY_PHONE_NUMBER: 'REPORTING_PARTY',
    REPORTING_PARTY_NOTES: 'REPORTING_PARTY',
} as const;

export const eventPanelNotificationGroupToNotifications = Object.keys(
    eventPanelEventNotificationToNotificationGroup
).reduce(
    (acc, notificationName) => {
        const group =
            eventPanelEventNotificationToNotificationGroup[
                notificationName as CadNextNotificationTypeEnumType
            ];
        if (group) {
            acc[group].push(notificationName as CadNextNotificationTypeEnumType);
        }
        return acc;
    },
    { MAIN: [], REPORTING_PARTY: [] } as Record<
        EventPanelNotificationGroup,
        CadNextNotificationTypeEnumType[]
    >
);
